import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { PayPalButtons } from "../components/PayPalButtons";
import { registerOrder, capturePayment } from "../apis/RangerOnlineApi";
import { useNavigate } from "react-router-dom";

const paypalkey =
  "AQ_h45WNptPIPU24kEyIBDdYfv41wqCo1qM-Q1cXB4i9eMF08D9gqirU0iSBzLXRaCSROfWmzhS4g7so";

const initialOptions = {
  "client-id": paypalkey,
  currency: "CAD",
  intent: "capture",
};

export const PayPalBox = (props) => {
  const { open, onClose, order } = props;
  const [loader, setLoader] = useState(false);

  let navigate = useNavigate();

  const getpurchaseUnits = () => {
    if (order) {
      let purchaseUnits = [];
      const totalTax =
        order.totalTax1 +
        order.totalTax2 +
        order.totalTax3 +
        order.totalTax4 +
        order.totalTax5 +
        order.totalTax6;
      let purchaseUnit = {
        reference_id: "1",
        order_id: "1",
        description: "Pick up order.",
        amount: {
          currency_code: "CAD",
          value: parseFloat(order.orderTotal.toFixed(2)),
          breakdown: {
            item_total: {
              currency_code: "CAD",
              value: parseFloat(
                order.promoDiscount > 0
                  ? order?.oldSubTotal.toFixed(2)
                  : order?.subTotal.toFixed(2)
              ),
            },
            handling: {
              currency_code: "CAD",
              value:
                Math.round(
                  (order?.tip + order?.serviceCharge + Number.EPSILON) * 100
                ) / 100,
            },
            tax_total: {
              currency_code: "CAD",
              value: parseFloat(totalTax?.toFixed(2)),
            },
            shipping: {
              currency_code: "CAD",
              value: order?.deliveryCharge
                ? parseFloat(order?.deliveryCharge?.toFixed(2))
                : 0,
            },
          },
        },
        //items: [],
      };
      /*for (let i = 0; i < order.OrderDetails.length; i++) {
        const orderItem = order.OrderDetails[i];
        const totalItemTax =
          Math.round(
            (orderItem.taxPerUnit1 +
              orderItem.taxPerUnit2 +
              orderItem.taxPerUnit3 +
              orderItem.taxPerUnit4 +
              orderItem.taxPerUnit5 +
              orderItem.taxPerUnit6 +
              Number.EPSILON) *
              100
          ) / 100;

        const item = {
          name: orderItem.name,
          quantity: orderItem.quantity,
          unit_amount: {
            value: orderItem.totalUnitPrice,
            currency_code: "CAD",
          },
          tax: { value: totalItemTax, currency_code: "CAD" },
          sku: orderItem.productId,
        };
        purchaseUnit.items.push(item);
      }*/

      if (order?.promoDiscount > 0) {
        Object.assign(purchaseUnit.amount.breakdown, {
          discount: {
            currency_code: "CAD",
            value: order.promoDiscount.toString(),
          },
        });
      }

      purchaseUnits.push(purchaseUnit);

      return purchaseUnits;
    }
  };

  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: getpurchaseUnits(),
    });
  };
  const onApprove = (data, actions) => {
    actions.order.authorize().then(async function (authorization) {
      setLoader(true);
      // Get the authorization id
      var authorizationID =
        authorization.purchase_units[0].payments.authorizations[0].id;
      let orderCopy = { ...order };
      orderCopy.paymentType = "card";
      const orderResponse = await registerOrder(orderCopy);

      if (orderResponse && orderResponse?.responseCode === "0000") {
        const captureResponse = await capturePayment(authorizationID);

        if (captureResponse?.status === "COMPLETED") {
          navigate(`/Success/${orderResponse.orderId}/${captureResponse.id}`);
        }
      }

      return null;
    });
  };
  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            padding: 2,
          }}
        >
          <DialogContent dividers style={{ width: "100%" }}>
            <div id="paypal-container">
              <PayPalButtons createOrder={createOrder} onApprove={onApprove} />
            </div>
          </DialogContent>
        </Box>
        <Backdrop sx={{ color: "#fff", zIndex: "99999" }} open={loader}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CircularProgress color="inherit" />
            <Typography>Creating the order please wait...</Typography>
          </Box>
        </Backdrop>
      </Box>
    </>
  );
};
